<div class="heading">
    About your work
</div>

<div>
    <p class="form-field-heading">Employment Type</p>
    <mat-button-toggle-group [(ngModel)]="selectEmployeeType" (change)="onEmploymentTypeChange()">
        <mat-button-toggle *ngFor="let option of EmploymentOptions"
                           value="{{ option.value }}">{{ option.displayName }}
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>

<form [formGroup]="salariedFormGroup" *ngIf="selectEmployeeType===EmployeeType.Salaried">
    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Industry</p>
        <mat-form-field class="col-xs-12">
            <input type="text" matInput placeholder="Please enter industry" formControlName="industry"
                   (ngModelChange)="filterIndustryList($event)"
                   [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let industry of industries" [value]="industry">
                    {{ industry }}
                </mat-option>
            </mat-autocomplete>
            <mat-error>{{ getErrorMessage(salariedFormGroup.controls.industry) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Current Company</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text" placeholder="Please enter company name" formControlName="company">
            <mat-error>{{ getErrorMessage(salariedFormGroup.controls.company) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <div class="form-field col-md-6">
            <div class="row">
                <p class="form-field-heading col-xs-12">Total Work Experience</p>
                <mat-form-field class="col-xs-6">
                    <input matInput type="number" formControlName="totalExperienceYear" placeholder="Years">
                    <mat-error>{{ getErrorMessage(salariedFormGroup.controls.totalExperienceYear) }}</mat-error>
                </mat-form-field>
                <mat-form-field class="col-xs-6">
                    <input matInput type="number" formControlName="totalExperienceMonth" min="0" step="1" max="11"
                           placeholder="Months">
                </mat-form-field>
            </div>
        </div>

        <div class="form-field col-md-6">
            <div class="row">
                <p class="form-field-heading col-xs-12">Net Monthly Salary</p>
                <mat-form-field class="col-xs-12">
                    <span matPrefix>₹&nbsp;</span>
                    <input matInput type="number" placeholder="Take home salary greater than ₹25000"
                           formControlName="income">
                    <mat-error>{{ getErrorMessage(salariedFormGroup.controls.income) }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="row">
        <span class="col-xs-12 errormsg" *ngIf="amountOfExperienceError">{{ amountOfExperienceError }}</span>
    </div>

    <div class="row">
        <div class="col-xs-6">
            <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
            </button>
        </div>
        <div class="col-xs-6">
            <div class="pull-right">
                <app-forward-button class="button-forward" [isLoading]="shouldShowLoader"
                                    (click)="onSubmit(salariedFormGroup)">NEXT
                </app-forward-button>
            </div>
        </div>
    </div>
</form>

<form [formGroup]="selfEmployedFormGroup" *ngIf="selectEmployeeType===EmployeeType.SelfEmployed">
    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Profession</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text" placeholder="Please enter profession" formControlName="profession"
                   [matAutocomplete]="autoProfession" (ngModelChange)="filterSelfEmployedProfessionsList($event)"
            >
            <mat-error>{{ getErrorMessage(selfEmployedFormGroup.controls.profession) }}</mat-error>
            <mat-autocomplete #autoProfession="matAutocomplete">
                <mat-option *ngFor="let prof of selfEmployedProfessions" [value]="prof">
                    {{ prof }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Industry</p>
        <mat-form-field class="col-xs-12">
            <input type="text" matInput placeholder="Please enter industry" formControlName="industry"
                   [matAutocomplete]="autoIndustry" (ngModelChange)="filterIndustryList($event)">
            <mat-error>{{ getErrorMessage(selfEmployedFormGroup.controls.industry) }}</mat-error>
            <mat-autocomplete #autoIndustry="matAutocomplete">
                <mat-option *ngFor="let industry of industries" [value]="industry">
                    {{ industry }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Name of the company/ Firm</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text" placeholder="Please enter company name" formControlName="company">
            <mat-error>{{ getErrorMessage(selfEmployedFormGroup.controls.company) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <div class="form-field col-xs-12 col-md-6">
            <div class="row">
                <p class="form-field-heading col-xs-12">Years in business</p>
                <mat-form-field class="col-xs-6">
                    <input matInput type="number" formControlName="totalExperienceYear" placeholder="Years">
                    <mat-error>{{ getErrorMessage(selfEmployedFormGroup.controls.totalExperienceYear) }}</mat-error>
                </mat-form-field>
                <mat-form-field class="col-xs-6">
                    <input matInput type="number" formControlName="totalExperienceMonth" min="0" step="1" max="11"
                           placeholder="Months">
                </mat-form-field>
            </div>
        </div>

        <div class="form-field col-xs-12 col-md-6">
            <div class="row">
                <p class="form-field-heading col-xs-12">Annual Income</p>
                <mat-form-field class="col-xs-12">
                    <input matInput type="number" formControlName="income" placeholder="Your total annual income"
                    >
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="row">
        <span class="col-xs-12 errormsg" *ngIf="amountOfExperienceError">{{ amountOfExperienceError }}</span>
    </div>

    <div class="row">
        <div class="col-xs-6">
            <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
            </button>
        </div>
        <div class="col-xs-6">
            <div class="pull-right">
                <app-forward-button class="button-forward" [isLoading]="shouldShowLoader"
                                    (click)="onSubmit(selfEmployedFormGroup)">
                    NEXT
                </app-forward-button>
            </div>
        </div>
    </div>
</form>

<form [formGroup]="professionalFormGroup" *ngIf="selectEmployeeType===EmployeeType.Professional">
    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Profession</p>
        <mat-form-field class="col-xs-12">
            <input type="text" matInput placeholder="Please enter profession" formControlName="profession"
                   [matAutocomplete]="auto" (ngModelChange)="filterProfessionalProfessionsList($event)">
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let prof of professionalProfessions" [value]="prof">
                    {{ prof }}
                </mat-option>
            </mat-autocomplete>
            <mat-error>{{ getErrorMessage(professionalFormGroup.controls.profession) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Name of the company / Firm</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text" placeholder="Please enter company name" formControlName="company">
            <mat-error>{{ getErrorMessage(selfEmployedFormGroup.controls.company) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <div class="form-field col-xs-12 col-md-6">
            <div class="row">
                <p class="form-field-heading col-xs-12">Years in profession

                </p>
                <mat-form-field class="col-xs-6">
                    <input matInput type="number" formControlName="totalExperienceYear" placeholder="Year">
                    <mat-error>{{ getErrorMessage(selfEmployedFormGroup.controls.totalExperienceYear) }}</mat-error>
                </mat-form-field>
                <mat-form-field class="col-xs-6">
                    <input matInput type="number" formControlName="totalExperienceMonth" min="0" step="1" max="11"
                           placeholder="Month">
                </mat-form-field>
            </div>
        </div>

        <div class="form-field col-xs-12 col-md-6">
            <div class="row">
                <p class="form-field-heading col-xs-12">Annual Income</p>
                <mat-form-field class="col-xs-12">
                    <input matInput type="number" formControlName="income" placeholder="Your total annual income"
                    >
                    <mat-error>{{ getErrorMessage(selfEmployedFormGroup.controls.income) }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="row">
        <span class="col-xs-12 errormsg" *ngIf="amountOfExperienceError">{{ amountOfExperienceError }}</span>
    </div>

    <div class="row">
        <div class="col-xs-6">
            <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
            </button>
        </div>
        <div class="col-xs-6">
            <div class="pull-right">
                <app-forward-button class="button-forward"
                                    [isLoading]="shouldShowLoader" (click)="onSubmit(professionalFormGroup)">
                    NEXT
                </app-forward-button>
            </div>
        </div>
    </div>
</form>
